import { GridRowSelectionModel } from '@mui/x-data-grid-pro';
import { DocumentationViewItem } from 'store/documentation/model/types';
import { getRowId } from '../../model';

export const SELECTION_MODEL_TYPE = {
  INCLUDE: 'include',
  EXCLUDE: 'exclude',
} as const;

/**
 * Resolves effective selected rows from DataGrid selection model.
 * - include: selected ids are explicit selection
 * - exclude: everything is selected except ids from the model
 */
export function resolveEffectiveSelectionFromGridModel(
  model: GridRowSelectionModel,
  rowsById: Map<string | number, DocumentationViewItem>
): DocumentationViewItem[] {
  const ids = Array.from(model.ids);

  if (model.type === SELECTION_MODEL_TYPE.EXCLUDE) {
    const idsSet = new Set(ids);
    return Array.from(rowsById.values()).filter(
      (row) => !idsSet.has(getRowId(row))
    );
  }

  return ids
    .map((id) => rowsById.get(id))
    .filter(Boolean) as DocumentationViewItem[];
}

export function createSelectedRowIdSet(
  items: Iterable<DocumentationViewItem>
): Set<string> {
  const ids = new Set<string>();
  for (const item of items) {
    ids.add(getRowId(item));
  }
  return ids;
}

export function hasSameIncludedRowSelection(
  currentSelectionModel: GridRowSelectionModel | undefined,
  ids: Set<string>
): boolean {
  if (
    !currentSelectionModel ||
    currentSelectionModel.type !== SELECTION_MODEL_TYPE.INCLUDE
  ) {
    return false;
  }

  if (currentSelectionModel.ids.size !== ids.size) {
    return false;
  }

  for (const id of ids) {
    if (!currentSelectionModel.ids.has(id)) {
      return false;
    }
  }

  return true;
}
